(ns common.schema.entities.token
  (:require [common.schema.schema-utils :as su]))

(defn- system-controlled-token-field
  [[attribute field]]
  [attribute (assoc field :field/system-semantics su/system-controlled-optional-field-semantics)])

(def schema
  (mapv
   system-controlled-token-field
   [[:token/created {:field/data-type             :data.type/datetime
                     :field/default-visibility    {:editor :editor.type/none
                                                   :grid   :editor.type/none
                                                   :filter :filter.type/none
                                                   :field-visibility :in-use-disabled}
                     :field/default-authorization {:access/read  :role/authenticated
                                                   :access/write :role/system}}]
    [:token/data {:field/data-type             :data.type/text
                  :field/default-visibility {:field-visibility :in-use-disabled}
                  :field/default-authorization {:access/read  :role/sys-admin
                                                :access/write :role/system}}]
    [:token/token {:field/data-type             :data.type/text
                   :field/default-visibility {:field-visibility :in-use-disabled}
                   :field/default-authorization {:access/read  :role/sys-admin
                                                 :access/write :role/system}}]
    [:token/api-token {:field/data-type             :data.type/text
                       :field/artificial?           true
                       :field/default-visibility {:field-visibility :in-use-disabled}
                       :field/default-authorization {:access/read  :role/admin
                                                     :access/write :role/system}}]
    [:token/device-id {:field/data-type             :data.type/text
                       :field/default-visibility {:field-visibility :in-use-disabled}
                       :field/default-authorization {:access/read  :role/authenticated
                                                     :access/write :role/system}}]
    [:token/device-nick-name {:field/data-type             :data.type/text
                              :field/default-visibility {:field-visibility :in-use-disabled}
                              :field/default-authorization {:access/read  :role/authenticated
                                                            :access/write :role/system}}]
    [:token/device-type {:field/data-type             :data.type/text
                         :field/default-visibility {:field-visibility :in-use-disabled}
                         :field/default-authorization {:access/read  :role/authenticated
                                                       :access/write :role/system}}]

    [:token/expires {:field/data-type             :data.type/datetime
                     :field/no-history?           true
                     :field/default-visibility {:field-visibility :in-use-disabled}
                     :field/default-authorization {:access/read  :role/authenticated
                                                   :access/write :role/system}}]
    [:token/updated {:field/data-type             :data.type/datetime
                     :field/no-history?           true
                     :field/default-visibility {:field-visibility :in-use-disabled}
                     :field/default-authorization {:access/read  :role/authenticated
                                                   :access/write :role/system}}]
    [:token/role {:field/data-type             :data.type/keyword
                  :field/default-visibility {:field-visibility :in-use-disabled}
                  :field/default-authorization {:access/read  :role/sys-admin
                                                :access/write :role/system}}]
    [:token/type {:field/data-type             :data.type/keyword
                  :field/default-visibility {:field-visibility :in-use-disabled}
                  :field/default-authorization {:access/read  :role/sys-admin
                                                :access/write :role/system}}]
    [:token/target {:field/data-type             :data.type/ref-single
                    :field/default-visibility {:field-visibility :in-use-disabled}
                    :field/default-authorization {:access/read  :role/sys-admin
                                                  :access/write :role/system}}]
    [:token/subject {:field/data-type             :data.type/ref-single
                     :field/default-visibility {:field-visibility :in-use-disabled}
                     :field/default-authorization {:access/read  :role/admin
                                                   :access/write :role/system}}]
    [:token/login-email {:field/data-type             :data.type/text
                         :field/default-visibility {:field-visibility :in-use-disabled}
                         :field/default-authorization {:access/read  :role/system
                                                       :access/write :role/system}}]
    [:token/ip-filters {:field/data-type             :data.type/text-edn
                        :field/default-visibility {:field-visibility :in-use-disabled}
                        :field/default-authorization {:access/read  :role/admin
                                                      :access/write :role/system}}]
    ;; Plugin authentication fields
    [:token/scopes {:field/data-type             :data.type/text-edn
                    :field/default-visibility {:field-visibility :in-use-disabled}
                    :field/default-authorization {:access/read  :role/authenticated
                                                  :access/write :role/system}}]
    ;; legacy field, should be deleted later
    [:token/plugin-device-name {:field/data-type             :data.type/text
                                :field/default-visibility {:field-visibility :in-use-disabled}
                                :field/default-authorization {:access/read  :role/authenticated
                                                              :access/write :role/system}}]
    [:token/plugin-connection-name {:field/data-type             :data.type/text
                                    :field/default-visibility {:field-visibility :in-use-disabled}
                                    :field/default-authorization {:access/read  :role/authenticated
                                                                  :access/write :role/system}}]
    [:token/plugin-type {:field/data-type             :data.type/keyword
                         :field/default-visibility {:field-visibility :in-use-disabled}
                         :field/default-authorization {:access/read  :role/authenticated
                                                       :access/write :role/system}}]
    [:token/last-used-at {:field/data-type             :data.type/datetime
                          :field/default-visibility {:field-visibility :in-use-disabled}
                          :field/default-authorization {:access/read  :role/authenticated
                                                        :access/write :role/system}}]
    [:token/refresh-token-parent {:field/data-type             :data.type/ref-single
                                  :field/default-visibility {:field-visibility :in-use-disabled}
                                  :field/default-authorization {:access/read  :role/system
                                                                :access/write :role/system}}]
    [:token/hard-expires {:field/data-type             :data.type/datetime
                          :field/default-visibility {:field-visibility :in-use-disabled}
                          :field/default-authorization {:access/read  :role/authenticated
                                                        :access/write :role/system}}]
    [:token/expiry-reminder-sent {:field/data-type             :data.type/keyword-multi
                                  :field/default-visibility {:field-visibility :in-use-disabled}
                                  :field/default-authorization {:access/read  :role/system
                                                                :access/write :role/system}}]
    [:token/connection-lifetime-kw {:field/data-type             :data.type/keyword
                                    :field/default-visibility {:field-visibility :in-use-disabled}
                                    :field/default-authorization {:access/read  :role/authenticated
                                                                  :access/write :role/system}}]
    ;; MCP session tracking — stored on the plugin refresh token so sessions
    ;; survive server restarts and are visible across pods.
    [:token/mcp-session-id {:field/data-type             :data.type/text-simple
                            :field/default-visibility    {:field-visibility :in-use-disabled}
                            :field/default-authorization {:access/read  :role/system
                                                          :access/write :role/system}}]
    [:token/mcp-session-last-seen {:field/data-type             :data.type/datetime
                                   :field/default-visibility    {:field-visibility :in-use-disabled}
                                   :field/default-authorization {:access/read  :role/system
                                                                 :access/write :role/system}}]]))
